import { context } from '@wikia/ad-engine';

export function getNobidContext(): object {
	const midBoxAdConfigs = context.get('options.replaceOpenWebWithMidBoxAd')
		? {
				mid_boxad: {
					sizes: [[300, 250]],
					siteId: '21872987104',
				},
			}
		: {};

	return {
		enabled: false,
		slots: {
			top_leaderboard: {
				sizes: [
					[728, 90],
					[970, 250],
				],
				siteId: 21872987104,
			},
			top_boxad: {
				sizes: [
					[300, 250],
					[300, 600],
				],
				siteId: 21872987104,
			},
			...midBoxAdConfigs,
			incontent_boxad: {
				sizes: [
					[300, 250],
					[300, 600],
					[160, 600],
					[300, 1050],
				],
				siteId: 21872987104,
			},
			bottom_leaderboard: {
				sizes: [
					[728, 90],
					[970, 250],
				],
				siteId: 21872987104,
			},
		},
	};
}
